/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023-2026 (original work) Open Assessment Technologies SA
 */

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
import { BULK_OPERATIONS_CONFIG_PERMISSION } from '@/components/BulkActionsDropdown/bulkActions.constants.js';

export const routing = [
    {
        path: [config.routes.explorer.home],
        guard: getPermissionsGuard([{ resource: 'portal.explorer', scopes: ['view'] }]),
        controller: () => import('./controllers/explorer')
    },
    {
        path: [config.routes.explorer.results],
        guard: getPermissionsGuard([{ resource: 'portal.results', scopes: ['view'] }]),
        controller: () => import('./controllers/results')
    },
    {
        path: [config.routes.explorer.bulkEdit],
        guard: getPermissionsGuard([BULK_OPERATIONS_CONFIG_PERMISSION]),
        controller: () => import('./controllers/bulkEdit')
    },
    {
        path: [config.routes.explorer.view],
        guard: getPermissionsGuard([{ resource: 'portal.explorer', scopes: ['view'] }]),
        controller: () => import('./controllers/view')
    }
];
